import { DropdownMenuItem } from '@aon/aon-tws-common-ui';
import { ActionMenuWrapper } from '@aon/aon-tws-common-ui/build/lib/components/Table';
import moment from 'moment';
import { User } from 'oidc-client';
import * as React from 'react';
import Constants from '../../constants';
import contentConstants from '../../contentConstants';
import { ISurveyListItem, SurveyStatusType, UserType } from '../../models';
import { UserHelper } from '../../utilities';

export interface IActionMenuProps {
	survey: ISurveyListItem;
	user?: User;
	CloneSurvey: (surveyId: number) => void;
	Expand: (shouldExpand: boolean) => void;
	GoToSurveyAdmin: (surveyId: number) => void;
	OpenCopySurveyModal: () => void;
	OpenDeleteSurveyModal: () => void;
}

export class ActionMenu extends React.Component<IActionMenuProps> {
	constructor(props: IActionMenuProps) {
		super(props);

		this.handleCopySurvey = this.handleCopySurvey.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
		this.handleRenameOnClick = this.handleRenameOnClick.bind(this);
	}

	public render() {
		return (
			<>
				<ActionMenuWrapper>
					<DropdownMenuItem section={true}>{contentConstants.ACTIONMENU_SECTION_GOTO}</DropdownMenuItem>
					<DropdownMenuItem onClick={() => this.props.GoToSurveyAdmin(this.props.survey.surveyId)}>
						{contentConstants.ACTIONMENU_LINK_SURVEYADMIN}
					</DropdownMenuItem>
					<DropdownMenuItem onClick={() => window.open(this.getReportingLink(), 'blank')} disabled={this.linkToReportingDisabled()}>
						{contentConstants.ACTIONMENU_LINK_SURVEYREPORTING}
					</DropdownMenuItem>
					<DropdownMenuItem section={true}>{contentConstants.ACTIONMENU_SECTION_COMMANDS}</DropdownMenuItem>
					<DropdownMenuItem onClick={this.handleCopySurvey}>{contentConstants.ACTIONMENU_COMMAND_COPYSURVEY}</DropdownMenuItem>
					<DropdownMenuItem onClick={this.handleRenameOnClick}>{contentConstants.ACTIONMENU_COMMAND_RENAME}</DropdownMenuItem>
					{this.getDeleteLink()}
				</ActionMenuWrapper>
			</>
		);
	}

	private handleCopySurvey() {
		const isInternal = this.props.user && this.props.user.profile.userType === Constants.PACKAGE_INTERNAL;
		if (isInternal) {
			this.props.OpenCopySurveyModal();
		} else {
			this.props.CloneSurvey(this.props.survey.surveyId);
		}
	}

	private handleDelete() {
		this.props.OpenDeleteSurveyModal();
	}

	private handleRenameOnClick() {
		this.props.Expand(true);
	}

	private getDeleteLink() {
		const showMenuItem =
			this.props.survey.surveyStatus === SurveyStatusType.Draft ||
			this.props.survey.surveyStatus === SurveyStatusType.DeletingInProgress ||
			this.props.survey.surveyStatus === SurveyStatusType.PublicSurveyTemplate;
		const disableMenuItem = this.props.survey.surveyStatus === SurveyStatusType.DeletingInProgress;
		if (showMenuItem) {
			return (
				<DropdownMenuItem onClick={this.handleDelete} disabled={disableMenuItem}>
					{contentConstants.ACTIONMENU_COMMAND_DELETE}
				</DropdownMenuItem>
			);
		}
		return <></>;
	}

	private getReportingLink() {
		const userId = UserHelper.getNumberFromUserProfile(this.props.user, 'external_userid');
		const isInternalUser = this.props.user && this.props.user.profile.userType === UserType.Internal;
		const isSurveyOwner = userId && userId === this.props.survey.userId;
		if (isInternalUser || isSurveyOwner) {
			return `${Constants.IDENTITY_SERVER_URL}sso/msuite`;
		}

		return Constants.MSUITE_BASE_URL;
	}

	private linkToReportingDisabled() {
		if (this.props.survey.closeDate) {
			const closeDate = moment(this.props.survey.closeDate).utc();
			const now = moment(Date.now()).utc();

			return now < closeDate;
		}
		return true;
	}
}
